<template>
  <div class="s5-wrapper">
    <div id="section5" class="page-section5">
      <!-- Akad -->
      <div class="s5-event fade-on-scroll">
        <h2 class="s5-title">Akad Nikah</h2>
        <p class="s5-date">{{ akadDate }}</p>
        <p class="s5-time">{{ akadTime }}</p>
        <p class="s5-loc-title">{{ client.lokasi_akad }}</p>
        <p class="s5-loc-desc">{{ client.alamat_akad }}</p>
      </div>

      <img :src="couplePhotoUrl" alt="Couple Akad" loading="lazy" class="s5-photo fade-on-scroll">

      <!-- Resepsi -->
      <div class="s5-event fade-on-scroll">
        <h2 class="s5-title">Resepsi</h2>
        <p class="s5-date">{{ resepsiDate }}</p>
        <p class="s5-time">{{ resepsiTime }}</p>
        <p class="s5-loc-title">{{ client.lokasi_resepsi }}</p>
        <p class="s5-loc-desc">{{ client.alamat_resepsi }}</p>
      </div>

      <div class="s5-divider fade-on-scroll">
        <span class="divider-line"></span>
        <svg class="divider-icon" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M20 2L24 14H38L27 21L31 33L20 26L9 33L13 21L2 14H16L20 2Z" fill="#4a5c74" opacity="0.3"/>
        </svg>
        <span class="divider-line"></span>
      </div>

      <div class="s5-location fade-on-scroll">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#4a5c74" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
          <circle cx="12" cy="10" r="3"></circle>
        </svg>
        <h3 class="s5-loc-heading">Lokasi Acara</h3>
        <div v-if="mapsEmbedUrl" class="s5-map-container">
          <iframe
            :src="mapsEmbedUrl"
            width="100%" height="220" style="border:0;" allowfullscreen="" loading="lazy"
            referrerpolicy="no-referrer-when-downgrade" title="Lokasi Acara">
          </iframe>
        </div>
        <a :href="mapsLink" target="_blank" rel="noopener" class="btn-buka-maps">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
            <circle cx="12" cy="10" r="3"></circle>
          </svg>
          BUKA MAPS
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'pinia';
import { useInvitationStore } from '@/store';
import moment from 'moment';

export default {
  name: 'AkadResepsiSection',
  computed: {
    ...mapState(useInvitationStore, ['client', 'randomGalleryPicks']),
    couplePhotoUrl() {
      const pick = this.randomGalleryPicks?.[1];
      if (pick) return `https://admin.itsyourdayofficial.com/gallery/${encodeURIComponent(pick)}`;
      const foto = this.client.foto_couple || this.client.foto_cover;
      return foto
        ? `https://admin.itsyourdayofficial.com/foto_cover/${foto}`
        : 'https://images.unsplash.com/photo-1519741497674-611481863552?auto=format&fit=crop&w=600&q=80';
    },
    akadDate() {
      return this.client.tgl_akad
        ? moment(this.client.tgl_akad).locale('id').format('dddd, DD MMMM YYYY')
        : '';
    },
    akadTime() {
      if (!this.client.tgl_akad) return '';
      const start = moment(this.client.tgl_akad).format('HH.mm');
      const end = this.client.tgl_akad_selesai
        ? moment(this.client.tgl_akad_selesai).format('HH.mm') + ' WIB'
        : 'Selesai';
      return `${start} WIB s.d ${end}`;
    },
    resepsiDate() {
      return this.client.tgl_resepsi
        ? moment(this.client.tgl_resepsi).locale('id').format('dddd, DD MMMM YYYY')
        : '';
    },
    resepsiTime() {
      if (!this.client.tgl_resepsi) return '';
      const start = moment(this.client.tgl_resepsi).format('HH.mm');
      const end = this.client.tgl_resepsi_selesai
        ? moment(this.client.tgl_resepsi_selesai).format('HH.mm') + ' WIB'
        : 'Selesai';
      return `${start} WIB s.d ${end}`;
    },
    mapsEmbedUrl() {
      return this.client.embed || null;
    },
    mapsLink() {
      return this.client.url_maps || 'https://maps.google.com';
    },
  },
  watch: {
    client(val) {
      if (val && val.id) {
        this.$nextTick(() => this.setupFadeObserver());
      }
    },
  },
  mounted() {
    this.setupFadeObserver();
  },
  beforeUnmount() {
    if (this._fadeObserver) this._fadeObserver.disconnect();
  },
  methods: {
    setupFadeObserver() {
      if (typeof IntersectionObserver === 'undefined') return;
      const observer = new IntersectionObserver(
        (entries) => entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('is-visible'); }),
        { threshold: 0.15 }
      );
      this.$el.querySelectorAll('.fade-on-scroll').forEach(el => observer.observe(el));
      this._fadeObserver = observer;
    },
  },
};
</script>

<style scoped>
.fade-on-scroll { opacity: 0; transform: translateY(40px); transition: opacity 1s ease-out, transform 1s ease-out; }
.fade-on-scroll.is-visible { opacity: 1; transform: translateY(0); }

.s5-wrapper {
  background-image: url('~@/assets/images/design-jawa-biru.jpg');
  background-size: cover; background-position: center;
  padding: 0.1px 0; overflow: hidden; position: relative;
}
.s5-wrapper::before {
  content: ''; position: absolute; inset: 0; background: rgba(255,255,255,0.82); z-index: 0;
}
.page-section5 {
  border-style: solid; background-image: url('~@/assets/images/cover1.jpeg');
  background-size: cover; background-position: center; position: relative;
  padding: 12rem 2rem; margin: 4rem 2rem; border-radius: 400px;
  display: flex; flex-direction: column; align-items: center;
  color: #1C2D4A; text-align: center; box-shadow: 0 10px 40px rgba(0,0,0,0.12);
  overflow: hidden; z-index: 1; border-width: 2px; border-color: white;
}
.page-section5::before {
  content: ''; position: absolute; inset: 0;
  background-image: radial-gradient(at center center, #F2EADED9 0%, #FFFFFF85 100%);
  z-index: 0; border-radius: inherit;
}
.page-section5 > * { position: relative; z-index: 1; }
.s5-event { display: flex; flex-direction: column; align-items: center; gap: 0.5rem; margin-bottom: 2rem; }
.s5-title { font-family: 'Great Vibes', cursive; font-size: 3.5rem; font-weight: 500; margin-bottom: 0.5rem; color: #0F1A2C; }
.s5-date, .s5-time { font-size: 1.15rem; font-family: 'Cormorant Garamond', serif; color: #1A2841; font-weight: 600; }
.s5-time { margin-bottom: 1rem; }
.s5-loc-title { font-weight: 700; font-size: 1.2rem; font-family: 'Cinzel', serif; color: #1A2841; }
.s5-loc-desc { font-size: 1.1rem; line-height: 1.5; margin-bottom: 1.2rem; color: #2D3A54; font-weight: 500; }
.s5-photo { width: 90%; max-width: 450px; border-radius: 20px; box-shadow: 0 10px 25px rgba(0,0,0,0.1); border: 4px solid #ffffff; margin: 1.5rem 0 3.5rem 0; object-fit: cover; }
.s5-divider { display: flex; align-items: center; gap: 16px; width: 80%; max-width: 360px; margin: 2rem 0; }
.divider-line { flex: 1; height: 1px; background: linear-gradient(90deg, transparent, #1A2841, transparent); }
.divider-icon { width: 32px; height: 32px; flex-shrink: 0; }
.s5-location { display: flex; flex-direction: column; align-items: center; gap: 1rem; width: 100%; padding-top: 1rem; }
.s5-loc-heading { font-family: 'Cinzel', serif; font-size: 1.3rem; letter-spacing: 2px; color: #0F1A2C; text-transform: uppercase; font-weight: 700; margin: 0; }
.s5-map-container { width: 100%; border-radius: 16px; overflow: hidden; box-shadow: 0 6px 20px rgba(0,0,0,0.1); border: 5px solid white; }
.btn-buka-maps {
  display: inline-flex; align-items: center; gap: 8px; background-color: #2F405A; color: #ffffff;
  text-decoration: none; padding: 0.85rem 2rem; border-radius: 8px; font-family: 'Cinzel', serif;
  font-size: 0.85rem; letter-spacing: 2px; text-transform: uppercase; font-weight: 600;
  transition: background 0.3s, transform 0.2s; margin-top: 0.5rem;
}
.btn-buka-maps:hover { background-color: #1A2841; transform: translateY(-2px); }

@media (max-width: 767px) {
  .page-section5 { padding: 8rem 1rem; margin: 1rem 1rem; }
}
</style>
